import UploadInvoice from './UploadInvoice';

export default UploadInvoice;
